<div edsGrid>
  <div edsRow>
    <div edsCol>
      <div edsSpacing="md"></div>
      <eds-section-header
        [title]="
          'products.price-historical-data-daily-fund-prices' | translate: fundId
        "
        [level]="6"
        edsSpacing="md"
      ></eds-section-header>
    </div>
  </div>

  <div
    edsSpacing="md"
    edsFlexbox
    flexWrap="wrap"
    alignItems="center"
    justifyContent="space-between"
  >
    <eds-dropdown
      edsCol
      [columnNumbers]="{ s: 4, m: 2, l: 3 }"
      ariaLabel="Dropdown"
      [dropdownId]="dropdownId"
      name="priceHistoricalDropDown"
      [label]="'products.TIME_PERIOD' | translate: fundId"
      [titleText]="getDropdownTitleText(this.selectedDropdownRange)"
      [items]="dropdownRange"
      (dropdownChange)="setDropdownDateRange($event)"
    ></eds-dropdown>
    <div
      edsFlexbox
      [justifyContent]="(isMobile$ | async) === false ? 'flex-end' : ''"
      [flexWrap]="(isMobile$ | async) === false ? 'wrap' : ''"
      flexDirection="row"
      alignItems="flex-start"
      class="dp-input-container"
      edsPadding
      [edsPaddingTop]="(isMobile$ | async) === false ? 'none' : 'sm'"
    >
      <div
        edsFlexbox
        alignItems="center"
        [flexDirection]="(isMobile$ | async) === false ? 'row' : 'column'"
      >
        <eds-duet-date-picker
          type="day"
          id="fromDate"
          [label]="'products.calendar-from' | translate: fundId"
          [min]="incDateStd"
          [max]="toDateStd"
          [value]="fromDateStd"
          (selected)="setCustomDateRange('fromDate', $event)"
          [opens]="(isMobile$ | async) === false ? 'left' : 'right'"
          [calendarHeading]="'common.date-picker-calendar-heading' | translate"
          [closeLabel]="'common.date-picker-close' | translate"
          [prevMonthLabel]="'common.date-picker-previous-button' | translate"
          [nextMonthLabel]="'common.date-picker-next-button' | translate"
          [monthSelectLabel]="'common.date-picker-select-month' | translate"
          [yearSelectLabel]="'common.date-picker-select-year' | translate"
          [selectedDateMessage]="'common.date-picker-selected-date' | translate"
          [buttonLabel]="'common.date-picker-button' | translate"
          [removeMargin]="isMobile$ | async"
        ></eds-duet-date-picker>
      </div>
      <div
        edsFlexbox
        alignItems="center"
        [flexDirection]="(isMobile$ | async) === false ? 'row' : 'column'"
      >
        <eds-duet-date-picker
          type="day"
          id="toDate"
          [label]="'products.calendar-to' | translate: fundId"
          [min]="fromDateStd"
          [max]="asOfDateStd"
          [value]="toDateStd"
          (selected)="setCustomDateRange('toDate', $event)"
          [calendarHeading]="'common.date-picker-calendar-heading' | translate"
          [closeLabel]="'common.date-picker-close' | translate"
          [prevMonthLabel]="'common.date-picker-previous-button' | translate"
          [nextMonthLabel]="'common.date-picker-next-button' | translate"
          [monthSelectLabel]="'common.date-picker-select-month' | translate"
          [yearSelectLabel]="'common.date-picker-select-year' | translate"
          [selectedDateMessage]="'common.date-picker-selected-date' | translate"
          [buttonLabel]="'common.date-picker-button' | translate"
          [removeMargin]="isMobile$ | async"
        ></eds-duet-date-picker>
      </div>
    </div>
  </div>

  <div edsRow edsSpacing="lg">
    <div edsCol>
      <eds-panel
        [enableHover]="false"
        [hasBorderRadius]="false"
        [hasBorders]="true"
        [hasPadding]="true"
        [hasShadows]="false"
        theme="white"
      >
        <div edsRow>
          <div edsCol>
            <div edsRow>
              <div edsCol edsSubGrid="layout-1" colGap="xs">
                <div>
                  <!-- TODO: no functions in templates -->
                  <eds-info-item
                    [info]="getInfoItem('NAV')"
                    edsSpacing="xs"
                  ></eds-info-item>
                  <eds-info-item
                    *ngIf="isSecondaryCalcTypeAvailable && showMarketPriceData"
                    [info]="getInfoItem('MARKET_PRICE')"
                    edsSpacing="xs"
                  ></eds-info-item>
                  <eds-info-item
                    *ngIf="showPop"
                    [info]="getInfoItem('POP')"
                    edsSpacing="xs"
                  ></eds-info-item>
                  <eds-info-item
                    *ngIf="showMoneyMarketPriceData"
                    [info]="getInfoItem('Fund-Level-Market-Nav')"
                    edsSpacing="xs"
                  ></eds-info-item>
                  <eds-info-item
                    *ngIf="showMoneyMarketPriceData"
                    [info]="getInfoItem('MASTER_FUND_NAV')"
                    edsSpacing="xs"
                  ></eds-info-item>
                  <eds-info-item
                    *ngIf="showMoneyMarketPriceData && showIntradayNavData"
                    [info]="getInfoItem('INTRADAY_NAV')"
                    edsSpacing="xs"
                  ></eds-info-item>
                </div>
                <div>
                  <eds-info-item
                    [info]="getInfoItem('HIGHEST_NAV')"
                    edsSpacing="xs"
                  ></eds-info-item>
                  <eds-info-item
                    *ngIf="isSecondaryCalcTypeAvailable && showMarketPriceData"
                    [info]="getInfoItem('HIGHEST_MARKET_PRICE')"
                    edsSpacing="xs"
                  ></eds-info-item>
                  <eds-info-item
                    [info]="getInfoItem('LOWEST_NAV')"
                    edsSpacing="xs"
                  ></eds-info-item>
                  <eds-info-item
                    *ngIf="isSecondaryCalcTypeAvailable && showMarketPriceData"
                    [info]="getInfoItem('LOWEST_MARKET_PRICE')"
                    edsSpacing="xs"
                  ></eds-info-item>
                </div>
              </div>
            </div>

            <div edsRow>
              <div edsCol>
                <p>
                  <span>{{
                    "products.price-historical-pricing-results"
                      | translate: fundId
                  }}</span>
                  &nbsp;
                  <span>{{
                    "products.calendar-from" | translate: fundId
                  }}</span>
                  &nbsp;
                  <b>{{ fromDate }}</b>
                  &nbsp;
                  <span>{{ "products.calendar-to" | translate: fundId }}</span>
                  &nbsp;
                  <b>{{ toDate }}</b>
                </p>
              </div>
            </div>

            <div edsRow>
              <div edsCol>
                <div edsSpacing="sm"></div>
                <button
                  #scroll
                  edsButton="secondary"
                  [hasIcon]="true"
                  size="normal"
                  (click)="onDownloadButtonClicked()"
                  data-analytics-no-event="true"
                >
                  <span class="ft__btn__txt">
                    {{
                      "products.price-download-historical-price-data"
                        | translate: fundId
                    }}
                    ({{
                      "products.xls-file-extension" | translate: fundId
                    }})</span
                  >
                  <eds-icon type="download" size="small"></eds-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </eds-panel>
    </div>
  </div>

  <div *ngIf="historicalList?.length > 0" edsRow edsSpacing="lg">
    <div edsCol>
      <table
        class="table"
        #tableResponsive
        [style.display]="(isHandheld$ | async) ? 'none' : ''"
      >
        <thead class="table__thead">
          <tr class="table__tr">
            <th class="table__th">{{ "products.date" | translate: fundId }}</th>
            <th class="table__th" *ngIf="showApplicationPrice">
              {{ "pds.APPLICATION_PRICE" | translate: fundId }}
            </th>
            <th class="table__th" *ngIf="showRedemptionPrice">
              {{ "pds.REDEMPTION_PRICE" | translate: fundId }}
            </th>
            <th class="table__th">
              {{ "pds.NAV_VALUE" | translate: fundId }}
            </th>
            <th class="table__th" *ngIf="showPop">
              {{ "products.POP_VALUE" | translate: fundId }}
            </th>
            <th class="table__th">
              {{ "pds.DAILY_NAV_CHANGE" | translate: fundId }}
            </th>
            <th class="table__th">
              {{ "products.DAILY_NAV_CHANGE_PERCENTAGE" | translate: fundId }}
            </th>
            <th class="table__th" *ngIf="showMoneyMarketPriceData">
              {{
                "products.Master-Fund-Level-Market-Nav" | translate: fundId
              }}({{ currencyCode }})
            </th>
            <th class="table__th" *ngIf="showMoneyMarketPriceData">
              {{ "products.Liquid-Asset-Daily_PERCENTAGE" | translate: fundId }}
            </th>
            <th class="table__th" *ngIf="showMoneyMarketPriceData">
              {{
                "products.Liquid-Asset-Weekly_PERCENTAGE" | translate: fundId
              }}
            </th>
            <th class="table__th" *ngIf="showMarketPriceData">
              {{ "pds.MARKET_VALUE" | translate: fundId }}
            </th>
            <th class="table__th" *ngIf="showMarketPriceData">
              {{ "products.Market-Price-Change" | translate: fundId }}
            </th>
            <th class="table__th" *ngIf="showMarketPriceData">
              {{
                "products.Market-Price-Change_PERCENTAGE" | translate: fundId
              }}
            </th>
            <th class="table__th" *ngIf="showMarketPriceData && showForETF">
              {{ "products.Bid-Ask-Spread" | translate: fundId }}
            </th>
            <th class="table__th" *ngIf="showMarketPriceData && showForETF">
              {{
                "products.Avg-of-Market-Price-vs-NAV-since-Inception"
                  | translate: fundId
              }}
            </th>
            <th class="table__th" *ngIf="showMarketPriceData">
              {{
                "products.Avg-of-Market-Price-vs-NAV-at-Close"
                  | translate: fundId
              }}
            </th>
            <th class="table__th" *ngIf="showMoneyMarketNetFlowColumn">
              {{ "products.Shareholder-Net-Flow" | translate: fundId }}
            </th>
            <th class="table__th" *ngIf="showMoneyMarketMasterNetFlowColumn">
              {{ "products.Master-Shareholder-Net-Flow" | translate: fundId }}
            </th>
          </tr>
        </thead>

        <tbody class="table__body">
          <tr class="table__tr" *ngFor="let pricingHistory of historicalList">
            <td class="table__td">{{ pricingHistory.asOfDate }}</td>
            <td class="table__td" *ngIf="showApplicationPrice">
              {{ pricingHistory.applicationPrice }}
            </td>
            <td class="table__td" *ngIf="showRedemptionPrice">
              {{ pricingHistory.redemptionPrice }}
            </td>
            <td class="table__td">{{ pricingHistory.nav }}</td>
            <td class="table__td" *ngIf="showPop">
              {{ pricingHistory.applicationPrice }}
            </td>
            <td class="table__td">
              {{ pricingHistory.navChangeValue }}
            </td>
            <td class="table__td">
              {{ pricingHistory.navChangePercent }}
            </td>
            <td class="table__td" *ngIf="showMoneyMarketPriceData">
              {{ pricingHistory.masterFundNav }}
            </td>
            <td class="table__td" *ngIf="showMoneyMarketPriceData">
              {{ pricingHistory.dailyLiquidAssetRatio }}
            </td>
            <td class="table__td" *ngIf="showMoneyMarketPriceData">
              {{ pricingHistory.weeklyLiquidAssetRatio }}
            </td>
            <td class="table__td" *ngIf="showMarketPriceData">
              {{ pricingHistory.marketPriceValue }}
            </td>
            <td class="table__td" *ngIf="showMarketPriceData">
              {{ pricingHistory.marketChangeValue }}
            </td>
            <td class="table__td" *ngIf="showMarketPriceData">
              {{ pricingHistory.marketChangePercent }}
            </td>
            <td class="table__td" *ngIf="showMarketPriceData && showForETF">
              {{ pricingHistory.bidOrAskSpread }}
            </td>
            <td class="table__td" *ngIf="showMarketPriceData && showForETF">
              {{ pricingHistory.discountOrPremiumInception }}
            </td>
            <td class="table__td" *ngIf="showMarketPriceData">
              {{ pricingHistory.discountOrPremiumAtLastClose }}
            </td>
            <td class="table__td" *ngIf="showMoneyMarketNetFlowColumn">
              {{ pricingHistory.netShareHolderFlow }}
            </td>
            <td class="table__td" *ngIf="showMoneyMarketMasterNetFlowColumn">
              {{ pricingHistory.masterNetShareHolderFlow }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div edsRow *ngFor="let card of cards">
    <div edsCol *ngIf="isHandheld$ | async">
      <eds-panel
        edsSpacing="sm"
        [hasBorders]="true"
        [hasBorderRadius]="false"
        [hasPadding]="true"
        theme="white"
      >
        <eds-info-item *ngFor="let item of card" [info]="item" edsSpacing="xs">
        </eds-info-item>
      </eds-panel>
    </div>
  </div>

  <div *ngIf="totalPages > 0" edsRow>
    <div edsCol>
      <eds-pagination
        [pageTitle]="pageTitle"
        [pages]="totalPages"
        (pageChanged)="onPageChanged($event)"
        [prevPageText]="'products.previous' | translate"
        [nextPageText]="'products.next' | translate"
        [ariaLabelGoToPage]="'products?.ariaLabelGoToPage' | translate"
        [ariaLabelPageNav]="'common.navigationLandmark' | translate"
      >
        ></eds-pagination
      >
    </div>
  </div>
</div>
